//:: AUTH
export const AUTH_LOGIN = 'AUTH_LOGIN'
export const AUTH_CHECK_LOGIN = 'AUTH_CHECK_LOGIN'
export const AUTH_LOGOUT = 'AUTH_LOGOUT'
export const AUTH_CUSTOMER_CONTACT = 'AUTH_CUSTOMER_CONTACT'
export const CLEAR_AUTH = 'CLEAR_AUTH'
export const AUTH_RESET_PASSWORD = 'AUTH_RESET_PASSWORD'
export const AUTH_REQUEST_RESET = 'AUTH_REQUEST_RESET'
export const AUTH_CONFIRM_RESET = 'AUTH_CONFIRM_RESET'
export const AUTH_WELCOME_WATCHED = 'AUTH_WELCOME_WATCHED'

//:: ENTITY CACHE
export const CLEAR_FETCH_CACHE = 'CLEAR_FETCH_CACHE'
export const CACHE_FETCHED = 'CACHE_FETCHED'
export const FETCH_ENTITY = 'FETCH_ENTITY'
export const GREEDY_FETCH_ENTITY = 'GREEDY_FETCH_ENTITY'